import React, { useState, useContext } from "react";
import ApiService from "../api/apiService";
import showSwal from "./swal";
import { common } from "../util/common";
import { WebSocketContext } from "../context/contexts";
import ModalShell from "./modal/ModalShell";
import ImageUploader from "./modal/ImageUploader";

const NAME_MAX = 100;

function EditConversationModal(props) {
  const WS = useContext(WebSocketContext);

  const { showHideEditConversationModal, conversationData } = props;
  const currentImageSrc = conversationData?.image
    ? `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${conversationData.image}`
    : null;

  const originalName = conversationData?.name || "";
  const [conversationName, setConversationName] = useState(originalName);
  const [image, setImage] = useState(null); // only set when a new file is picked
  const [saving, setSaving] = useState(false);

  const trimmedName = conversationName.trim();
  const dirty = trimmedName !== originalName.trim() || !!image;
  const canSave = dirty && trimmedName.length > 0 && !saving;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSave) return;
    setSaving(true);

    try {
      const formData = new FormData();
      formData.append("conversation_image", image ? image : null);
      formData.append("data", JSON.stringify({ name: trimmedName }));

      const _conversation = await ApiService.conversation.updateConversationDetail(formData, conversationData?.id);
      const { success, conversation_action } = _conversation;

      if (success) {
        WS.websocketInstance.sendMessage({ message: conversation_action, type: "user-actions-chat" });
        showHideEditConversationModal();
        showSwal(common.success.CONVERSATION_UPDATED);
        return;
      }
      showSwal(common.errors.UPDATE_CONVERSATION_ERROR);
    } catch (err) {
      console.error(err);
      showSwal(common.errors.UPDATE_CONVERSATION_ERROR);
    }
    setSaving(false); // failure: keep the form open so nothing is lost
  };

  return (
    <ModalShell
      title='Edit conversation'
      subtitle={originalName}
      size='sm'
      onClose={showHideEditConversationModal}
      footer={
        <>
          <button type='button' className='bh-btn bh-btn--ghost' onClick={showHideEditConversationModal} disabled={saving}>
            Cancel
          </button>
          <button type='submit' form='bh-edit-conversation-form' className='bh-btn bh-btn--primary' disabled={!canSave}>
            {saving && <span className='bh-spinner' />}
            {saving ? "Saving…" : "Save changes"}
          </button>
        </>
      }
    >
      <form id='bh-edit-conversation-form' onSubmit={handleSubmit}>
        <div className='bh-field'>
          <span className='bh-label'>Conversation image</span>
          <ImageUploader file={image} onChange={setImage} currentSrc={currentImageSrc} disabled={saving} />
        </div>
        <div className='bh-field'>
          <div className='bh-field__row'>
            <label className='bh-label' htmlFor='bh-edit-name'>
              Conversation name
            </label>
            <span className='bh-hint' style={{ marginTop: 0 }}>
              {conversationName.length}/{NAME_MAX}
            </span>
          </div>
          <input
            id='bh-edit-name'
            data-autofocus
            type='text'
            className='bh-input'
            value={conversationName}
            maxLength={NAME_MAX}
            onChange={(e) => setConversationName(e.target.value)}
            disabled={saving}
            required
          />
          {!trimmedName && <p className='bh-hint bh-hint--error'>A name is required.</p>}
        </div>
      </form>
    </ModalShell>
  );
}

export default EditConversationModal;
